// Parent layout for /groups/$id/admin/* (Spaces). Auth gate + Outlet.

import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { requireLeaderOrAdmin } from '@/lib/route-guards';

export const Route = createFileRoute('/_authed/groups/$id/admin')({
  beforeLoad: async ({ context, params }) => {
    await requireLeaderOrAdmin(context, {
      groupId: params.id,
      bounceTo: () =>
        redirect({ to: '/groups/$id', params: { id: params.id } }),
    });
  },
  component: Outlet,
});
